import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-server-error',
  templateUrl: './server-error.page.html',
  styleUrls: ['./server-error.page.scss']
})
export class ServerErrorPage implements OnInit {

  constructor(
    private http: HttpClient,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.http.get(environment.apiUrl, { observe: 'response' }).subscribe({
      next: () => this.returnToPreviousPage(),
      error: (error: any) => {
        if (error.status !== 0 && !(error.status >= 500 && error.status < 600)) {
          this.returnToPreviousPage();
        }
      }
    });
  }

  private returnToPreviousPage(): void {
    const returnUrl = sessionStorage.getItem('serverErrorReturnUrl') || '/';
    sessionStorage.removeItem('serverErrorReturnUrl');
    this.router.navigateByUrl(returnUrl, { replaceUrl: true });
  }
}
